// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor__emoji__container {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  font-size: calc(var(--cms-font-size-heading1) * 2);
  width: 100%;
  max-height: 110px;
  height: 100%;
  z-index: 1;
}

.editor__layout__actions {
  padding: calc(var(--cms-padding-xxs) * 1px) calc(var(--cms-padding) * 1px) 0 calc(var(--cms-padding) * 1px);
  margin-bottom: calc(var(--cms-margin-xs) * 1px);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.editor__layout__actions .editor__layout__actions__inner,
.editor__emoji__container .editor__emoji__view {
  width: 100% !important;
  max-width: var(--remirror-editor-width) !important;
}

.editor__layout__actions .editor__layout__actions__inner {
  padding: calc(var(--cms-padding) * 1px) calc(var(--cms-padding-sm) * 1px) calc(var(--cms-padding) * 1px)
    calc(var(--cms-padding-sm) * 1px);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: calc(var(--cms-padding-lg) * 1px);
}

.editor__layout__actions .layout__action {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: calc(var(--cms-padding-xxs) * 1px);
  cursor: pointer;
}

.editor__layout__actions .layout__action::hover {
  color: calc(var(--cms-color-text));
  fill: calc(var(--cms-color-text));
  transition: all 200ms ease-in-out;
}

.editor__layout__actions .layout__action > span {
  display: inline-block;
}

.layout__action .layout__action-icon {
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.layout__action .layout__action-icon svg {
  color: var(--cms-color-text-secondary, rgba(0, 0, 0, 0.65));
}

.layout__action .layout__action-text {
  color: var(--cms-color-text-secondary, rgba(0, 0, 0, 0.65));
  font-family: var(--cms-font-family, 'SF Pro Text');
  font-size: var(--cms-font-size-lg, 16px);
  font-style: normal;
  font-weight: var(--cms-typography-font-weight-strong, 600);
  line-height: var(--cms-line-height-lg, 24px); /* 150% */
}
`, "",{"version":3,"sources":["webpack://./../editor/src/components/EditorHeader/EditorHeader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,kDAAkD;EAClD,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,2GAA2G;EAC3G,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE;qCACmC;EACnC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;EAC3D,kDAAkD;EAClD,wCAAwC;EACxC,kBAAkB;EAClB,0DAA0D;EAC1D,4CAA4C,EAAE,SAAS;AACzD","sourcesContent":[".editor__emoji__container {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: center;\n  font-size: calc(var(--cms-font-size-heading1) * 2);\n  width: 100%;\n  max-height: 110px;\n  height: 100%;\n  z-index: 1;\n}\n\n.editor__layout__actions {\n  padding: calc(var(--cms-padding-xxs) * 1px) calc(var(--cms-padding) * 1px) 0 calc(var(--cms-padding) * 1px);\n  margin-bottom: calc(var(--cms-margin-xs) * 1px);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.editor__layout__actions .editor__layout__actions__inner,\n.editor__emoji__container .editor__emoji__view {\n  width: 100% !important;\n  max-width: var(--remirror-editor-width) !important;\n}\n\n.editor__layout__actions .editor__layout__actions__inner {\n  padding: calc(var(--cms-padding) * 1px) calc(var(--cms-padding-sm) * 1px) calc(var(--cms-padding) * 1px)\n    calc(var(--cms-padding-sm) * 1px);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: calc(var(--cms-padding-lg) * 1px);\n}\n\n.editor__layout__actions .layout__action {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: calc(var(--cms-padding-xxs) * 1px);\n  cursor: pointer;\n}\n\n.editor__layout__actions .layout__action::hover {\n  color: calc(var(--cms-color-text));\n  fill: calc(var(--cms-color-text));\n  transition: all 200ms ease-in-out;\n}\n\n.editor__layout__actions .layout__action > span {\n  display: inline-block;\n}\n\n.layout__action .layout__action-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.layout__action .layout__action-icon svg {\n  color: var(--cms-color-text-secondary, rgba(0, 0, 0, 0.65));\n}\n\n.layout__action .layout__action-text {\n  color: var(--cms-color-text-secondary, rgba(0, 0, 0, 0.65));\n  font-family: var(--cms-font-family, 'SF Pro Text');\n  font-size: var(--cms-font-size-lg, 16px);\n  font-style: normal;\n  font-weight: var(--cms-typography-font-weight-strong, 600);\n  line-height: var(--cms-line-height-lg, 24px); /* 150% */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
